module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h4 class="icon-header '+
((__t=( icon ))==null?'':__t)+
'">'+
((__t=( alias ))==null?'':__t)+
'</h4> ';
 if ( isOwner ) { 
__p+=' <fieldset><legend>'+
((__t=( i18n.tc("Unit", "User options") ))==null?'':__t)+
'</legend> ';
 if ( subscriptionName ) { 
__p+=' <button data-click="settings-subscription">'+
((__t=( i18n.tc("Unit", "Subscription") ))==null?'':__t)+
'</button> ';
 } 
__p+=' ';
 if (transientSettingsHome) { 
__p+=' <button data-click="nav-location">'+
((__t=( i18n.tc("Unit", "Location") ))==null?'':__t)+
'</button> ';
 } 
__p+=' ';
 if ( isAutomotive && transientSettingsAutomotive ) { 
__p+=' <button data-click="settings-vehicle">'+
((__t=( i18n.tc("Unit", "Vehicle") ))==null?'':__t)+
'</button> ';
 } 
__p+=' <button data-click="settings-alias">'+
((__t=( i18n.tc("Unit", "Device name") ))==null?'':__t)+
'</button></fieldset> ';
 } 
__p+='  ';
 if ( ( isInstallerAutomotive && isAutomotive ) || ( isInstallerHome && isHome ) ) { 
__p+=' <fieldset><legend>'+
((__t=( i18n.tc("Unit", "Installer options") ))==null?'':__t)+
'</legend> ';
 if ( isTechSupport || ( isInstallerAutomotive && isAutomotive )) { 
__p+=' <button data-click="settings-retest">'+
((__t=( i18n.tc("Unit", "Retest") ))==null?'':__t)+
'</button> ';
 } 
__p+='  ';
 if ( isTechSupport && isHome || isInstallerHome && isHome && isCurrentInstaller && ! subscriptionName ) { 
__p+=' <button '+
((__t=( ( ! subscriptionName ) ? " class=\"primary\"" : "" ))==null?'':__t)+
' data-click="settings-configure">'+
((__t=( i18n.tc("Unit", "Configure") ))==null?'':__t)+
'</button> ';
 } 
__p+=' ';
 if ( subscriptionName ) { 
__p+=' <button data-click="settings-complaint">'+
((__t=( i18n.tc( "Unit", "Complaint" ) ))==null?'':__t)+
'</button> ';
 } 
__p+='  ';
 if ( isTechSupport && ! subscriptionName ) { 
__p+=' <button data-click="settings-reset">'+
((__t=( i18n.tc( "Unit", "Reset metadata" ) ))==null?'':__t)+
'</button> ';
 } 
__p+=' </fieldset> ';
 } 
__p+=' <fieldset class="button-wrap"> ';
 if ( subscriptionName ) { 
__p+=' <button data-click="settings-devices">'+
((__t=( i18n.tc("Unit", "My devices") ))==null?'':__t)+
'</button> ';
 if ( canControlAuto ) { 
__p+=' <button class="primary" data-click="settings-open" '+
((__t=( ( offline ) ? " disabled" : "" ))==null?'':__t)+
'> '+
((__t=( i18n.tc("Unit", "Open %s").format(alias) ))==null?'':__t)+
'</button> ';
 } 
__p+=' ';
 if ( canControlHome ) { 
__p+=' <button class="primary" data-click="settings-open" '+
((__t=( ( offline ) ? " disabled" : "" ))==null?'':__t)+
'> '+
((__t=( i18n.tc("Unit", "Open %s").format(alias) ))==null?'':__t)+
'</button> ';
 } 
__p+=' ';
 } else { 
__p+=' ';
 if ( isInstallerHome && isHome ) { 
__p+=' <button data-click="settings-install">'+
((__t=( i18n.tc("Unit", "Continue") ))==null?'':__t)+
'</button> ';
 } else if ( isInstallerAutomotive && isAutomotive ) { 
__p+=' <button class="primary" data-click="settings-install">'+
((__t=( i18n.tc("Unit", "Continue") ))==null?'':__t)+
'</button> ';
 } else { 
__p+=' <button class="primary" data-click="settings-install">'+
((__t=( i18n.tc("Unit", "Create subscription") ))==null?'':__t)+
'</button> ';
 } 
__p+=' ';
 } 
__p+=' </fieldset><div data-region="settings-container"></div>';
}
return __p;
};
